import { mappedFilters } from './constants/sitemapConstants';
import { sitemapNavigationLinks } from './constants/sitemapNavigationLinks';
import { linksEnabled } from './constants/sitemapConstants';

export function getFilterType(filterType = '') {
    return mappedFilters[filterType] || filterType;
}
// This helper cheks for uri segment of filter type
export function getFilterUriType(filterType = '') {
    return Object.keys(mappedFilters).reduce((acc, key) => {
        if (mappedFilters[key] === filterType) {
            acc = key;
        }
        return acc;
    }, filterType);
}

export const getNavLinks = (vertical = '') => {
    const links = sitemapNavigationLinks.nav[vertical] || [];
    const verticalEnabledLinks = linksEnabled[vertical] || [];

    // Check nav item to make sure it's a valid facet and if link is usable or not
    return links.filter(({ label }) => verticalEnabledLinks.includes(label));
};
